export const FETCH_SPINNER_LOADING = "FETCH_SPINNER_LOADING";
export const SET_SPINNER_LOADING = "SET_SPINNER_LOADING";
export const ACTION_SET_SIDE_BAR_QUICK_ACTION =
  "ACTION_SET_SIDE_BAR_QUICK_ACTION";
export const MUTATION_SET_SIDE_BAR_QUICK_ACTION =
  "MUTATION_SET_SIDE_BAR_QUICK_ACTION";

export const GETTER_SIDE_BAR_QUICK_ACTION = "GETTER_SIDE_BAR_QUICK_ACTION";
export const ACTION_SET_CLIENT_SELECTED = "ACTION_SET_CLIENT_SELECTED";
export const MUATAION_SET_CLIENT_SELECTED = "MUATAION_SET_CLIENT_SELECTED";
export const GETTER_CLIENT_SELECTED = "GETTER_CLIENT_SELECTED";

export const GETTER_API_CURRENT_VERSION = 'GETTER_API_CURRENT_VERSION';
export const ACTION_API_CURRENT_VERSION = 'ACTION_API_CURRENT_VERSION';
export const MUTATION_API_CURRENT_VERSION = 'MUTATION_API_CURRENT_VERSION';



// WEBPACK FOOTER //
// ./src/store/modules/common/constants.js